
import claire from "./files/clairecz.jpeg"
import duramdusam from "./files/duramdusam.jpeg"
import emijade from "./files/emijade.jpeg"
import zackcombo from "./files/zackcombo.jpeg"



export const submissions = [
  
  {
    "timestamp": "12/25/2023 18:28:27",
    "email": "emi_anderson@fitnyc.edu",
    "name": "Emi and Jade",
    "location": "Rochester, NY",
    "artFile": emijade,
    "artLinkOrText": "",
    "otherInfo": "We made pine needle simple syrup! We used Sugar, water, lemon juice, and pine needles gathered by Jade to make this syrup and we’ve made a couple of yummy cocktails over the holiday weekend with it :)",
    "hide": ""
  },
  {
    "timestamp": "12/26/2023 16:01:35",
    "email": "cweaverzeman@gmail.com",
    "name": "Claire Weaver-Zeman",
    "location": "Brooklyn",
    "artFile": claire,
    "artLinkOrText": "",
    "otherInfo": "Material is oil on canvas",
    "hide": ""
  },
  {
    "timestamp": "12/26/2023 23:25:27",
    "email": "persephonejbennett@gmail.com",
    "name": "Persephone",
    "location": "Chebeague Island, Maine",
    "artFile": "",
    "artLinkOrText": "Christmas without\n\nthere are empty spaces on this island\nand they stay empty\nno matter who comes to fill them\n\nand prayer flags hang from every branch\nsewn by Deb, in her hospice\nwe whispered peace into them at her funeral\n\nand Ed’s son stands at the counter \nlooking just like him\nmaybe i’ll someday forget that he has legs too\n\nand Martha, she’s been gone for a while\nbut the library she built still stands\nand i still knit with her leftovers\n\nand William i think about a lot\ni taught him to sail\nand waved to his dad on his boat\n\ni should place a skipping rock on his stone, one of these days\n\nand Roy’s tractor is in some barn now\ni don’t know where\nbut everyone my age had a ride on it\n\nand Dana, i look out for your daughter\ni text her all the time\nand when Mother’s Day comes around \ni tell her i am thinking of you and her\n\nand Dad, his memoir is in the library \nand i hang an ornament with his name\non a scraggly tree\nand that’s not enough, nothing is enough\n\n\nand there are others and others and others\nand the chickens dash across the road\nand i wave to my neighbors\nand try to love my island more",
    "otherInfo": "",
    "hide": ""
  },
  {
    "timestamp": "12/27/2023 12:08:31",
    "email": "alawi@amasud.xyz",
    "name": "Alawi",
    "location": "On the road between DC and Nashville",
    "artFile": duramdusam,
    "artLinkOrText": "",
    "otherInfo": "This is my friend omer! We're on a road trip together right now, took this picture on it.\n\nHe wants people to more critically engage with his art at @go.rashi",
    "hide": ""
  },
    {
    "timestamp": "12/28/2023 10:34:18",
    "email": "zackkeven@gmail.com",
    "name": "Zack (sometimes friend of Greebo)",
    "location": "Beer Talera, Rajasthan",
    "artFile": zackcombo,
    "artLinkOrText": "",
    "otherInfo": "",
    "hide": "",
  },
   { "timestamp": "12/28/2023 10:34:18",
    "email": "scs8782@nyu.edu",
    "name": "Sadie Shea",
    "location": "Hawaii!",
    "artFile": '',
    "videoFile":"https://www.youtube.com/embed/CfGoWBslKXI?si=160Bt8eLb18jmEvF",
    "artLinkOrText": "",
    "otherInfo": "",
    "hide": "",
  },

       {
    "timestamp": "12/28/2023 10:34:18",
    "email": "verity.cook@hotmail.co.uk",
    "name": "Verity",
    "location": "Berlin",
    "artFile": '',

    "artLinkOrText": "We are all at home\nConnecting with each other\nIn separate rooms",
    "otherInfo": "",
    "hide": "",
  },
         {
    "timestamp": "12/28/2023 10:34:18",
    "email": "",
    "name": "Zev",
    "location": "Brooklyn, New York",
    "artFile": '',
    "videoFile":"https://www.youtube.com/embed/OPuSIzfnvDs?si=T947baptryUcoumc",
    "artLinkOrText": "",
    "otherInfo": "",
    "hide": "",
  },
         {
    "timestamp": "12/28/2023 10:34:18",
    "email": "",
    "name": "vicki",
    "location": "sf",
    "artFile": '',
    "videoFile":"",
    "artLinkOrText": "christmas day \n\nsay my favorite sound in the entire world right now is this type of laugh\nit is too loud and overall the sort of thing in which\na dog and dog walker passing by might jump\nslightly at the crooning pitch of carefree,\n\nand that's also part of the favoriteness,\nthat the laugher has no idea that it's my favorite sound,\nor that they startled this stranger, and all i want right now\nis for them to keep laughing, laugh and laugh and laugh\n\nuntil all the dogs in this shiny town go berserk howling \nyowling they just cannot stand it ! poor things \nthey are so confused ! foaming at the mouth \nand dragging their walking companions \n\nhapless down streets, and all the neighbors \nthat have kids instead of dogs poke out to rubberneck \nthis thunderstorm of guffaws, this tornado \nof humans hurling and canines hurtling\n\naround on leashes at 40 miles an hour who \nas they whiz by are positively beseeching this laugher \nto stop so that they can walk again upright next to \ntheir sweating huskies and psychotic labradoodle mixes\n\nand also grab their other sandal, kindly, it's been lost \nin the kerfuffle and if the laugher knew maybe they would be \na little embarrassed at the inconvenience \nbut they aren't! and they don't! they don't\n\nhear them, they do not see \nany of this, they are quite \npreoccupied and there isn't even anything \nparticularly funny, only the tune \n\nof the bellows that richochet off bluebird \ncanyon, rollicking in the wind\n\n\n______________\nand gathering no moss\n\nfrozen milk in plastic\nplanters peanut packages\ndrawing condensation, that\n\nwhich pools. it's a dusty table. \nhe cooks under a tarp sleeps\nin the same room he eats. \n\nnot much to say, beijing is too \nsour, shanghai too sweet\nhe is the goldilocks man\n\nof china, he will never settle\nthere is no just\nthere is no right\n\nhe does not fall asleep\nin the perfect bed rather\nhe jumps out the window \n\nand keeps running\nwith trousers rolled\nand gathering no moss",
    "otherInfo": "",
    "hide": "",
  }
]